import API from '@/axios'
import { AxiosResponse } from 'axios'
import {
	IAgreementAddonResponse,
	ICreateAgreementAddonParams,
	IGetAgreementAddonsParams,
	IUpdateAgreementAddonParams,
} from './types'

const AgreementEndpoint = '/models/agreements'

export default {
	async getAgreementAddons({ agreementId, query }: IGetAgreementAddonsParams): Promise<
		AxiosResponse<{
			data: IAgreementAddonResponse[]
			meta: {
				current_page: number
				from: number
				last_page: number
				per_page: number
				to: number
				total: number
			}
		}>
	> {
		return await API.get(`${AgreementEndpoint}/${agreementId}/exam-addons`, {
			params: query,
		})
	},

	async createAgreementAddon({
		agreementId,
		payload,
	}: ICreateAgreementAddonParams): Promise<AxiosResponse<IAgreementAddonResponse>> {
		return await API.post(`${AgreementEndpoint}/${agreementId}/exam-addons`, payload)
	},

	async updateAgreementAddon({
		payload,
		agreementAddonId,
		agreementId,
	}: IUpdateAgreementAddonParams & { agreementId: number }): Promise<
		AxiosResponse<IAgreementAddonResponse>
	> {
		return await API.put(
			`${AgreementEndpoint}/${agreementId}/exam-addons/${agreementAddonId}`,
			payload
		)
	},

	async removeAgreementAddon({
		agreementAddonId,
		agreementId,
	}: {
		agreementAddonId: number
		agreementId: number
	}): Promise<AxiosResponse<{ message: string | undefined }>> {
		return await API.delete(
			`${AgreementEndpoint}/${agreementId}/exam-addons/${agreementAddonId}`
		)
	},
}
